import { render, staticRenderFns } from "./VerifyAuthentication.vue?vue&type=template&id=03ea27e3"
import script from "./VerifyAuthentication.vue?vue&type=script&lang=js"
export * from "./VerifyAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports